var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4623 6.19162C11.4244 6.28299 11.3604 6.36109 11.2782 6.41604C11.1959 6.471 11.0993 6.50035 11.0004 6.50037H1.00039C0.901446 6.50044 0.8047 6.47116 0.722403 6.41623C0.640106 6.36129 0.575959 6.28317 0.538082 6.19176C0.500206 6.10035 0.490304 5.99976 0.509629 5.90271C0.528954 5.80567 0.576638 5.71654 0.646644 5.64662L5.64664 0.646616C5.69308 0.600128 5.74823 0.563248 5.80892 0.538086C5.86962 0.512924 5.93469 0.499973 6.00039 0.499973C6.0661 0.499973 6.13117 0.512924 6.19186 0.538086C6.25256 0.563248 6.30771 0.600128 6.35414 0.646616L11.3541 5.64662C11.424 5.71658 11.4716 5.8057 11.4909 5.90271C11.5101 5.99973 11.5002 6.10026 11.4623 6.19162Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollapse);
export default __webpack_public_path__ + "static/media/iconCollapse.9d29f0a8b69f2919747fc80ae951308f.svg";
export { ForwardRef as ReactComponent };